import {IRetirePlan} from "pages/retirementPlan/types";

export const getLowestRetirement = (values: IRetirePlan) => {
  return (
    values.outcome *
    0.7 *
    Math.pow(1 + values.inflationrate / 100, values.retriment_age - values.age)
  ).toLocaleString();
};
